<template>
  <v-layout>
    <v-flex>
      <v-row align="center">
        <v-col cols="12" class="py-0">
          <v-container fluid py-0>
            <v-row align="baseline">
              <h1 class="headline">Reports</h1>

              <v-spacer></v-spacer>

              <v-autocomplete
                :items="availableReportsList"
                v-model="selectedReport"
                label="Select Report"
                item-text="node.name"
                item-value="node"
                dense
                solo
                class="mt-1"
              ></v-autocomplete>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-card>
        <reports-list-filters-form
          :report="selectedReport"
        ></reports-list-filters-form>
      </v-card>

      <div v-if="debug">{{ availableReports }}</div>
    </v-flex>
  </v-layout>
</template>

<script>
import { AVAILABLE_REPORTS_SEARCH_QUERY } from "../../../constants/graphql";
import ReportsListFiltersForm from "./ReportsListFiltersForm";
import { nonCaseToSnakeCase } from "../../../helpers/index";

export default {
  name: "ReportsList",

  components: {
    ReportsListFiltersForm,
  },

  data() {
    return {
      drawer: true,
      debug: false,
      selectedReport: {},
    };
  },

  computed: {
    availableReportsList() {
      return this.availableReports && this.availableReports.edges.length > 0
        ? this.availableReports.edges.filter((report) =>
            this.$store.getters.hasAccessTo(
              `reports:${nonCaseToSnakeCase(report.node.name)}`
            )
          )
        : [];
    },
  },

  watch: {
    availableReportsList(list) {
      if (list.length > 0) {
        this.selectedReport = list[0].node;
      }
    },
  },

  apollo: {
    availableReports: {
      query: AVAILABLE_REPORTS_SEARCH_QUERY,
      fetchPolicy: "network-only",
      error(err) {
        console.error(err);
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/reports/ReportsList.vue